import React from 'react';
import { DeckNav } from './components/DeckNav';
import { DownloadPdfButton } from './components/DownloadPdfButton';
import { CoverSection } from './components/sections/CoverSection';
import { OpportunitySection } from './components/sections/OpportunitySection';
import { IdeaSection } from './components/sections/IdeaSection';
import { PillarSection } from './components/sections/PillarSection';
import { TeaserSection } from './components/sections/TeaserSection';
import { HookSection } from './components/sections/HookSection';
import { EntryPointsSection } from './components/sections/EntryPointsSection';
import { NetworkSection } from './components/sections/NetworkSection';
import { SignalsSection } from './components/sections/SignalsSection';
import { ModelSection } from './components/sections/ModelSection';
import { ScopeSection } from './components/sections/ScopeSection';
import { ClosingSection } from './components/sections/ClosingSection';
export function App() {
  return <div className="w-full bg-background font-body text-white antialiased" data-id="element-0" data-mp="3ijxsgzk2wgo4">
      <DeckNav data-id="element-1" data-mp="3ihv0wb3a2fha" />
      <main className="w-full" data-id="element-2" data-mp="3mlj8gtrwtb2j">
        <CoverSection data-id="element-3" data-mp="3mkrgdsxitvh0" />
        <OpportunitySection data-id="element-4" data-mp="3mjzrt22ccy08" />
        <IdeaSection data-id="element-5" data-mp="3mj6jvxrnc2gi" />
        <PillarSection data-id="element-6" data-mp="3rcj31sdk3h1v" />
        <TeaserSection data-id="element-7" data-mp="3rdas0kcnegj6" />
        <HookSection data-id="element-8" data-mp="3rd1bdndhtlq5" />
        <EntryPointsSection data-id="element-9" data-mp="3relvej26lm9r" />
        <NetworkSection data-id="element-10" data-mp="6hovayao7c0" />
        <SignalsSection data-id="element-11" data-mp="4n53zyrel9i" />
        <ModelSection data-id="element-12" data-mp="56qxrrj5tst" />
        <ScopeSection data-id="element-13" data-mp="2zl3bdjx5744s" />
        <ClosingSection data-id="element-14" data-mp="2zllijblcf2rh" />
      </main>
      <DownloadPdfButton data-id="element-15" data-mp="2zmo7vf30ox5a" />
    </div>;
}